import { CardPermissions } from 'pages/profile/partials/sideAction/bulkEdit';

import type { ReactNode } from 'react';

type PermissionsStepProps = {
  visibleToDefault: number;
};

export default function PermissionsStep({
  visibleToDefault,
}: PermissionsStepProps): ReactNode {
  return (
    <CardPermissions visibleToDefault={visibleToDefault} showTitle={false} />
  );
}
